import TodoCard from './TodoCard'
import EmptyState from '../../components/ui/EmptyState'

function TodoList({ todos, users = [], onEdit, onDelete, onToggle, onToggleSubtask, onAddSubtask, onAdd }) {
  if (todos.length === 0) {
    return (
      <EmptyState
        icon="✅"
        title="No tasks yet"
        description="Add your first task to start tracking"
        action={onAdd}
        actionLabel="Add Task"
      />
    )
  }

  return (
    <div className="flex flex-col gap-3">
      {todos.map(todo => (
        <TodoCard
          key={todo.id}
          todo={todo}
          users={users}
          onEdit={onEdit}
          onDelete={onDelete}
          onToggle={onToggle}
          onToggleSubtask={onToggleSubtask}
          onAddSubtask={onAddSubtask}
        />
      ))}
    </div>
  )
}

export default TodoList
